<template>
  <a-modal
    :class="['new-user-guide-wrapper', className, `new-user-guide-step-${currentGuideStep}`]"
    v-model:visible="showGuide"
    :style="configData.style"
    :closable="false"
    :centered="true"
    :maskClosable="false"
    :width="configData.width || width"
    :footer="null"
    wrapClassName="newuser-guide-modal"
  >
    <div :class="['guide-arrow']" v-if="configData.arrow"></div>
    <div class="user-guide-content">
      <component
        :is="stepComponents[currentGuideStep]"
        @changeGuideStep="changeGuideStep"
        @closeGuide="closeGuide"
        :key="currentGuideStep"
        :currentGuideStep="currentGuideStep"
        :stepLen="stepComponents.length"
        :dataSource="dataSource"
      />
    </div>
  </a-modal>
</template>
<script setup>
import { defineProps, defineEmits, ref, computed, watch } from 'vue';
import Store from '@/utils/localStorage';

const props = defineProps({
  guideStorageKey: {
    type: String,
    default: 'new-user-guide',
  },
  stepComponents: {
    type: Array,
    default() {
      return [];
    },
  },
  bodyStyle: {
    type: Object,
    default() {
      return {};
    },
  },
  dataSource: {
    type: Object,
    default() {
      return {};
    },
  },
  className: String,
  width: {
    type: Number,
    default: 520,
  },
});
const emit = defineEmits(['closeGuide', 'changeGuideShowStatus']);

const currentGuideStep = ref(0);
const guideFinish = ref(false);
const configData = ref({});
watch(
  props.dataSource,
  (newValue = {}) => {
    configData.value = newValue[currentGuideStep.value] || {};
  },
  {
    immediate: true,
  }
);
watch(
  currentGuideStep,
  (newValue = {}) => {
    configData.value = props.dataSource[newValue] || {};
  },
  {
    immediate: true,
  }
);
let showGuide = computed({
  get() {
    return !guideFinish.value && !Store.get(props.guideStorageKey);
  },
  set(val) {
    guideFinish.value = true;
    return val;
  },
});
function closeGuide() {
  Store.set(props.guideStorageKey, true);
  showGuide = false;
  guideFinish.value = true;
  emit('closeGuide');
}
function changeGuideStep() {
  currentGuideStep.value += 1;
  if (currentGuideStep.value === props.stepComponents.length) {
    // 最后一步
    closeGuide();
  }
}

watch(showGuide, newValue => emit('changeGuideShowStatus', newValue), {
  immediate: true,
});
</script>
